
import MuiTableHead, { TableHeadProps } from '@mui/material/TableHead';

const EDTableHead = (props: TableHeadProps) => {
  return <MuiTableHead {...props} />;
};

export default EDTableHead;
